import { Modal } from "@ucchub/ui";
import { ConfirmModalContent } from "@ucchub/ui/src/Modal";
import { t } from "i18next";

interface CustomerFormAddProductButtonProps {
  isOpen: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

const CustomerDiscardPopup = ({
  isOpen,
  onConfirm,
  onCancel,
}: CustomerFormAddProductButtonProps) => {
  const handleOnClose = () => {
    onCancel?.();
  };

  return (
    <Modal
      srName={t("core:customers:back_to_customers_discard.discard")}
      isOpen={isOpen}
      isClosable
      size={2}
      animate
      onClose={handleOnClose}
    >
      <ConfirmModalContent
        heading={
          t("core:customers:back_to_customers_discard.discard_information") ||
          "Discard changes"
        }
        message={t("core:customers:back_to_customers_discard.message")}
        body={t("core:customers:back_to_customers_discard.body")}
        cancelMessage={
          t("core:customers:back_to_customers_discard.discard_button") ||
          "Discard"
        }
        onCancel={onCancel}
        confirmMessage={t("core:customers:discard_popup:discard_ButtonText")}
        onConfirm={onConfirm}
        loading={false}
      />
    </Modal>
  );
};
export default CustomerDiscardPopup;
